import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminActivity from "../admin/master-data/activity/AdminActivity";
import UserManagement from "../admin/user-management/UserManagement";
import UserManagementTambah from "../admin/user-management/UserManagementTambah";
import AdminRole from "../admin/master-data/role/AdminRole";
import AdminBank from "../admin/master-data/bank/AdminBank";
import AdminJobPosition from "../admin/master-data/jobPosition/AdminJobPosition";
import AdminPriceType from "../admin/master-data/priceType/AdminPriceType";
import AdminWorkingArea from "../admin/master-data/workingArea/AdminWorkingArea";
import AdminWorkingStatus from "../admin/master-data/workingStatus/AdminWorkingStatus";
import AdminEmployee from "../admin/master-data/employee/AdminEmployee";
import AdminEmployeeTambah from "../admin/master-data/employee/AdminEmployeeTambah";
import AdminEmployeeEdit from "../admin/master-data/employee/AdminEmployeeEdit";
import AdminEmployeeDetail from "../admin/master-data/employee/AdminEmployeeDetail";
import AdminUnitWeight from "../admin/master-data/unitWeight/AdminUnitWeight";
import AdminVegetableType from "../admin/master-data/vegetableType/AdminVegetableType";
import AdminVegetable from "../admin/master-data/vegetable/AdminVegetable";
import AdminVegetableTambah from "../admin/master-data/vegetable/AdminVegetableTambah";
import AdminVegetableEdit from "../admin/master-data/vegetable/AdminVegetableEdit";
import AdminVegetableDetail from "../admin/master-data/vegetable/AdminVegetableDetail";
import AdminVegetablePrice from "../admin/master-data/vegetablePrice/AdminVegetablePrice";
import AdminVegetablePriceTambah from "../admin/master-data/vegetablePrice/AdminVegetablePriceTambah";
import AdminVegetablePriceEdit from "../admin/master-data/vegetablePrice/AdminVegetablePriceEdit";
import AdminVegetablePriceDetail from "../admin/master-data/vegetablePrice/AdminVegetablePriceDetail";
import Dashboard from "../admin/dashboard/Dashboard";
import UserManagementChangePassword from "../admin/user-management/UserManagementChangePassword";
import UserManagamentEdit from "../admin/user-management/UserManagementEdit";
import UserManagementDetail from "../admin/user-management/UserManagementDetail";
import AdminFarmer from "../admin/master-data/farmer/AdminFarmer";
import AdminFarmerTambah from "../admin/master-data/farmer/AdminFarmerTambah";
import AdminFarmerEdit from "../admin/master-data/farmer/AdminFarmerEdit";
import AdminFarmerDetail from "../admin/master-data/farmer/AdminFarmerDetail";
import AdminCustomerGroup from "../admin/master-data/customerGroup/AdminCustomerGroup";
import AdminCustomerRegion from "../admin/master-data/customerRegion/AdminCustomerRegion";
import AdminGoodsCategory from "../admin/master-data/goodsCategory/AdminGoodsCategory";
import AdminGoodsOperational from "../admin/master-data/goodsOperational/AdminGoodsOperational";
import AdminGoodsOperationalTambah from "../admin/master-data/goodsOperational/AdminGoodsOperationalTambah";
import AdminGoodsOperationalEdit from "../admin/master-data/goodsOperational/AdminGoodsOperationalEdit";
import AdminGoodsOperationalDetail from "../admin/master-data/goodsOperational/AdminGoodsOperationalDetail";
import AdminDeliveryVehicle from "../admin/master-data/deliveryVehicle/AdminDeliveryVehicle";
import AdminDeliveryVehicleTambah from "../admin/master-data/deliveryVehicle/AdminDeliveryVehicleTambah";
import AdminDeliveryVehicleEdit from "../admin/master-data/deliveryVehicle/AdminDeliveryVehicleEdit";
import AdminDeliveryVehicleDetail from "../admin/master-data/deliveryVehicle/AdminDeliveryVehicleDetail";
import AdminCustomer from "../admin/master-data/customer/AdminCustomer";
import AdminCustomerTambah from "../admin/master-data/customer/AdminCustomerTambah";
import AdminCustomerEdit from "../admin/master-data/customer/AdminCustomerEdit";
import AdminCustomerDetail from "../admin/master-data/customer/AdminCustomerDetail";
import FarmerDailyActivity from "../farmer/dailyActivity/FarmerDailyActivity";
import FarmerDailyActivityTambah from "../farmer/dailyActivity/FarmerDailyActivityTambah";
import FarmerDailyActivityEdit from "../farmer/dailyActivity/FarmerDailyActivityEdit";
import FarmerDailyActivityDetail from "../farmer/dailyActivity/FarmerDailyActivityDetail";
import SpvReportDailyActivity from "../supervisor/report/dailyActivityAll/SpvReportDailyActivity";
import SpvReportActivity from "../supervisor/report/dailyActivity/SpvReportActivity";
import SpvReportNoActivity from "../supervisor/report/dailyNoActivity/SpvReportNoActivity";
import SpvReportActivityDetail from "../supervisor/report/dailyActivityDetail/SpvReportActivityDetail";
import FarmerHarvestEstimate from "../farmer/harvestEstimate/FarmerHarvestEstimate";
import FarmerHarvestEstimateTambah from "../farmer/harvestEstimate/FarmerHarvestEstimateTambah";
import FarmerHarvestEstimateEdit from "../farmer/harvestEstimate/FarmerHarvestEstimateEdit";
import FarmerHarvestEstimateDetail from "../farmer/harvestEstimate/FarmerHarvestEstimateDetail";
import FarmerHarvest from "../farmer/harvest/FarmerHarvest";
import FarmerHarvestTambah from "../farmer/harvest/FarmerHarvestTambah";
import FarmerHarvestEdit from "../farmer/harvest/FarmerHarvestEdit";
import FarmerHarvestDetail from "../farmer/harvest/FarmerHarvestDetail";
import FarmerHarvestEstimateDashboard from "../farmer/harvestEstimate/FarmerHarvestEstimateDashboard";
import FarmerHarvestDashboardTambah from "../farmer/harvest/FarmerHarvestDashboardTambah";
import SpvReportHarvestEstimate from "../supervisor/report/harvestEstimate/SpvReportHarvestEstimate";
import SpvReportHarvest from "../supervisor/report/harvest/SpvReportHarvest";
import SpvReportHarvestFarmer from "../supervisor/report/harvestFarmer/SpvReportHarvestFarmer";
import SpvReportHarvestEstimateFarmer from "../supervisor/report/harvestEstimateFarmer/SpvReportHarvestEstimateFarmer";
import AdminPurchaseOrder from "../farmer/purchaseOrder/AdminPurchaseOrder";
import AdminPurchaseOrderTambah from "../farmer/purchaseOrder/AdminPurchaseOrderTambah";
import AdminPurchaseOrderTerima from "../farmer/purchaseOrder/AdminPurchaseOrderTerima";
import AdminPurchaseOrderEdit from "../farmer/purchaseOrder/AdminPurchaseOrderEdit";
import AdminPurchaseOrderDetail from "../farmer/purchaseOrder/AdminPurchaseOrderDetail";
import AdminPurchaseOrderCust from "../admin/purchaseOrderCust/AdminPurchaseOrderCust";
import AdminPurchaseOrderCustTambah from "../admin/purchaseOrderCust/AdminPurchaseOrderCustTambah";
import AdminPurchaseOrderCustEdit from "../admin/purchaseOrderCust/AdminPurchaseOrderCustEdit";
import AdminPurchaseOrderCustDetail from "../admin/purchaseOrderCust/AdminPurchaseOrderCustDetail";
import AdminPurchaseOrderCustTerima from "../admin/purchaseOrderCust/AdminPurchaseOrderCustTerima";
import AdminStockVegetables from "../admin/stock-vegetables/AdminStockVegetables";
import AdminStockVegetablesTambah from "../admin/stock-vegetables/AdminStockVegetablesTambah";
import AdminStockVegetablesEdit from "../admin/stock-vegetables/AdminStockVegetablesEdit";
import AdminStockVegetablesDetail from "../admin/stock-vegetables/AdminStockVegetablesDetail";
import AdminStockOperationalGoods from "../admin/stock-operational-goods/AdminStockOperationalGoods";
import AdminStockOperationalGoodsTambah from "../admin/stock-operational-goods/AdminStockOperationalGoodsTambah";
import AdminStockOperationalGoodsEdit from "../admin/stock-operational-goods/AdminStockOperationalGoodsEdit";
import AdminStockOperationalGoodsDetail from "../admin/stock-operational-goods/AdminStockOperationalGoodsDetail";
import AdminDeliveryOrder from "../admin/delivery-order/AdminDeliveryOrder";
import AdminDeliveryOrderTambah from "../admin/delivery-order/AdminDeliveryOrderTambah";
import AdminDeliveryOrderEdit from "../admin/delivery-order/AdminDeliveryOrderEdit";
import AdminDeliveryOrderDetail from "../admin/delivery-order/AdminDeliveryOrderDetail";
import AdminInvoice from "../admin/invoice/AdminInvoice";
import AdminInvoiceTambah from "../admin/invoice/AdminInvoiceTambah";
import AdminInvoiceEdit from "../admin/invoice/AdminInvoiceEdit";
import AdminInvoiceDetail from "../admin/invoice/AdminInvoiceDetail";
import AdminPurchaseOrderToko from "../farmer/purchaseOrder/AdminPurchaseOrderToko";
import FarmerDebtPlastic from "../farmer/debt-plastic/FarmerDebtPlastic";
import FarmerDebtPlasticTambah from "../farmer/debt-plastic/FarmerDebtPlasticTambah";
import FarmerDebtPlasticEdit from "../farmer/debt-plastic/FarmerDebtPlasticEdit";
import FarmerDebtPlasticDetail from "../farmer/debt-plastic/FarmerDebtPlasticDetail";
import AdminOperationalSubmission from "../admin/operational-submission/AdminOperationalSubmission";
import AdminOperationalSubmissionTambah from "../admin/operational-submission/AdminOperationalSubmissionTambah";
import AdminOperationalSubmissionEdit from "../admin/operational-submission/AdminOperationalSubmissionEdit";
import AdminOperationalSubmissionDetail from "../admin/operational-submission/AdminOperationalSubmissionDetail";
import AdminOperationalSubmissionTerima from "../admin/operational-submission/AdminOperationalSubmissionTerima";
import FarmerDebtMoney from "../farmer/debt-money/FarmerDebtMoney";
import FarmerDebtMoneyTambah from "../farmer/debt-money/FarmerDebtMoneyTambah";
import FarmerDebtMoneyEdit from "../farmer/debt-money/FarmerDebtMoneyEdit";
import FarmerDebtMoneyDetail from "../farmer/debt-money/FarmerDebtMoneyDetail";
import AdminPurchaseOrderFarmer from "../admin/purchaseOrderFarmer/AdminPurchaseOrderFarmer";
import AdminPurchaseOrderFarmerTambah from "../admin/purchaseOrderFarmer/AdminPurchaseOrderFarmerTambah";

export default function RouteMenu() {
  return (
    <Routes>
      <Route path="" element={<Dashboard />} />
      <Route path="aktifitas" element={<AdminActivity />} />
      <Route path="role" element={<AdminRole />} />
      <Route path="bank" element={<AdminBank />} />
      <Route path="jabatan" element={<AdminJobPosition />} />
      <Route path="tipe-harga" element={<AdminPriceType />} />
      <Route path="area" element={<AdminWorkingArea />} />
      <Route path="status-karyawan" element={<AdminWorkingStatus />} />
      <Route path="karyawan" element={<AdminEmployee />} />
      <Route path="karyawan/tambah" element={<AdminEmployeeTambah />} />
      <Route path="karyawan/edit/:id" element={<AdminEmployeeEdit />} />
      <Route path="karyawan/detail/:id" element={<AdminEmployeeDetail />} />
      <Route path="petani" element={<AdminFarmer />} />
      <Route path="petani/tambah" element={<AdminFarmerTambah />} />
      <Route path="petani/edit/:id" element={<AdminFarmerEdit />} />
      <Route path="petani/detail/:id" element={<AdminFarmerDetail />} />
      <Route path="satuan-berat" element={<AdminUnitWeight />} />
      <Route path="tipe-sayuran" element={<AdminVegetableType />} />
      <Route path="sayuran" element={<AdminVegetable />} />
      <Route path="sayuran/tambah" element={<AdminVegetableTambah />} />
      <Route path="sayuran/edit/:id" element={<AdminVegetableEdit />} />
      <Route path="sayuran/detail/:id" element={<AdminVegetableDetail />} />
      <Route path="harga-sayuran" element={<AdminVegetablePrice />} />
      <Route
        path="harga-sayuran/tambah"
        element={<AdminVegetablePriceTambah />}
      />
      <Route
        path="harga-sayuran/edit/:id"
        element={<AdminVegetablePriceEdit />}
      />
      <Route
        path="harga-sayuran/detail/:id"
        element={<AdminVegetablePriceDetail />}
      />
      <Route path="customer-group" element={<AdminCustomerGroup />} />
      <Route path="customer-region" element={<AdminCustomerRegion />} />
      <Route path="kategori-produk" element={<AdminGoodsCategory />} />
      <Route path="produk-operational" element={<AdminGoodsOperational />} />
      <Route
        path="produk-operational/tambah"
        element={<AdminGoodsOperationalTambah />}
      />
      <Route
        path="produk-operational/edit/:id"
        element={<AdminGoodsOperationalEdit />}
      />
      <Route
        path="produk-operational/detail/:id"
        element={<AdminGoodsOperationalDetail />}
      />
      <Route path="kendaraan-pengiriman" element={<AdminDeliveryVehicle />} />
      <Route
        path="kendaraan-pengiriman/tambah"
        element={<AdminDeliveryVehicleTambah />}
      />
      <Route
        path="kendaraan-pengiriman/edit/:id"
        element={<AdminDeliveryVehicleEdit />}
      />
      <Route
        path="kendaraan-pengiriman/detail/:id"
        element={<AdminDeliveryVehicleDetail />}
      />
      <Route path="customer" element={<AdminCustomer />} />
      <Route path="customer/tambah" element={<AdminCustomerTambah />} />
      <Route path="customer/edit/:id" element={<AdminCustomerEdit />} />
      <Route path="customer/detail/:id" element={<AdminCustomerDetail />} />
      <Route path="aktifitas-harian" element={<FarmerDailyActivity />} />
      <Route
        path="aktifitas-harian/tambah"
        element={<FarmerDailyActivityTambah />}
      />
      <Route
        path="aktifitas-harian/edit/:id"
        element={<FarmerDailyActivityEdit />}
      />
      <Route
        path="aktifitas-harian/detail/:id"
        element={<FarmerDailyActivityDetail />}
      />
      <Route path="estimasi-panen" element={<FarmerHarvestEstimate />} />
      <Route
        path="estimasi-panen/tambah"
        element={<FarmerHarvestEstimateTambah />}
      />
      <Route
        path="estimasi-panen/edit/:id"
        element={<FarmerHarvestEstimateEdit />}
      />
      <Route
        path="estimasi-panen/detail/:id"
        element={<FarmerHarvestEstimateDetail />}
      />
      <Route path="panen" element={<FarmerHarvest />} />
      <Route path="panen/tambah" element={<FarmerHarvestTambah />} />
      <Route
        path="panen/dashboard/tambah/:id"
        element={<FarmerHarvestDashboardTambah />}
      />
      <Route path="panen/edit/:id" element={<FarmerHarvestEdit />} />
      <Route path="panen/detail/:id" element={<FarmerHarvestDetail />} />
      <Route path="panen/:id" element={<FarmerHarvestEdit />} />
      <Route
        path="panen/dashboard"
        element={<FarmerHarvestEstimateDashboard />}
      />
      <Route path="user-management" element={<UserManagement />} />
      <Route path="user-management/tambah" element={<UserManagementTambah />} />
      <Route
        path="user-management/ubah-password/:id"
        element={<UserManagementChangePassword />}
      />
      <Route path="user-management/edit/:id" element={<UserManagamentEdit />} />
      <Route
        path="user-management/detail/:id"
        element={<UserManagementDetail />}
      />
      <Route
        path="laporan/aktifitas-petani/"
        element={<SpvReportDailyActivity />}
      />
      <Route
        path="laporan/aktifitas-petani/beraktifitas"
        element={<SpvReportActivity />}
      />
      <Route
        path="laporan/aktifitas-petani/tidak-beraktifitas"
        element={<SpvReportNoActivity />}
      />
      <Route
        path="laporan/aktifitas-petani/detail"
        element={<SpvReportActivityDetail />}
      />
      <Route
        path="laporan/estimasi-panen/"
        element={<SpvReportHarvestEstimate />}
      />
      <Route path="laporan/panen/" element={<SpvReportHarvest />} />
      <Route path="laporan/panen/petani" element={<SpvReportHarvestFarmer />} />
      <Route
        path="laporan/estimasi-panen/petani"
        element={<SpvReportHarvestEstimateFarmer />}
      />

      <Route path="/nota-petani" element={<AdminPurchaseOrder />} />
      <Route
        path="/nota-petani/tambah"
        element={<AdminPurchaseOrderTambah />}
      />
      <Route
        path="/nota-petani/terima/:id"
        element={<AdminPurchaseOrderTerima />}
      />
      <Route
        path="/nota-petani/terima-toko/:id"
        element={<AdminPurchaseOrderToko />}
      />
      <Route
        path="/nota-petani/edit/:id"
        element={<AdminPurchaseOrderEdit />}
      />
      <Route
        path="/nota-petani/detail/:id"
        element={<AdminPurchaseOrderDetail />}
      />
      <Route path="/po-toko" element={<AdminPurchaseOrderCust />} />
      <Route
        path="/po-toko/tambah"
        element={<AdminPurchaseOrderCustTambah />}
      />
      <Route
        path="/po-toko/edit/:id"
        element={<AdminPurchaseOrderCustEdit />}
      />
      <Route
        path="/po-toko/detail/:id"
        element={<AdminPurchaseOrderCustDetail />}
      />
      <Route
        path="/po-toko/terima/:id"
        element={<AdminPurchaseOrderCustTerima />}
      />
      <Route path="/stock-sayuran" element={<AdminStockVegetables />} />
      <Route
        path="/stock-sayuran/tambah"
        element={<AdminStockVegetablesTambah />}
      />
      <Route
        path="/stock-sayuran/edit/:id"
        element={<AdminStockVegetablesEdit />}
      />
      <Route
        path="/stock-sayuran/detail/:id"
        element={<AdminStockVegetablesDetail />}
      />
      <Route
        path="/stock-barang-operational"
        element={<AdminStockOperationalGoods />}
      />
      <Route
        path="/stock-barang-operational/tambah"
        element={<AdminStockOperationalGoodsTambah />}
      />
      <Route
        path="/stock-barang-operational/edit/:id"
        element={<AdminStockOperationalGoodsEdit />}
      />
      <Route
        path="/stock-barang-operational/detail/:id"
        element={<AdminStockOperationalGoodsDetail />}
      />
      <Route path="/surat-jalan/" element={<AdminDeliveryOrder />} />
      <Route
        path="/surat-jalan/tambah"
        element={<AdminDeliveryOrderTambah />}
      />
      <Route
        path="/surat-jalan/edit/:id"
        element={<AdminDeliveryOrderEdit sjBack={false} />}
      />
      <Route
        path="/surat-jalan/detail/:id"
        element={<AdminDeliveryOrderDetail />}
      />
      <Route
        path="/surat-jalan/kembali/:id"
        element={<AdminDeliveryOrderEdit sjBack={true} />}
      />
      <Route path="/invoice" element={<AdminInvoice />} />
      <Route path="/invoice/tambah" element={<AdminInvoiceTambah />} />
      <Route path="/invoice/edit/:id" element={<AdminInvoiceEdit />} />
      <Route path="/invoice/detail/:id" element={<AdminInvoiceDetail />} />

      <Route path="hutang-plastik" element={<FarmerDebtPlastic />} />
      <Route
        path="hutang-plastik/tambah"
        element={<FarmerDebtPlasticTambah />}
      />
      <Route
        path="hutang-plastik/edit/:id"
        element={<FarmerDebtPlasticEdit />}
      />
      <Route
        path="hutang-plastik/detail/:id"
        element={<FarmerDebtPlasticDetail />}
      />

      <Route
        path="pengajuan-operasional"
        element={<AdminOperationalSubmission />}
      />
      <Route
        path="pengajuan-operasional/tambah"
        element={<AdminOperationalSubmissionTambah />}
      />
      <Route
        path="pengajuan-operasional/edit/:id"
        element={<AdminOperationalSubmissionEdit />}
      />
      <Route
        path="pengajuan-operasional/detail/:id"
        element={<AdminOperationalSubmissionDetail />}
      />
      <Route
        path="pengajuan-operasional/terima/:id"
        element={<AdminOperationalSubmissionTerima />}
      />

      <Route path="hutang" element={<FarmerDebtMoney />} />
      <Route path="hutang/tambah" element={<FarmerDebtMoneyTambah />} />
      <Route path="hutang/edit/:id" element={<FarmerDebtMoneyEdit />} />
      <Route path="hutang/detail/:id" element={<FarmerDebtMoneyDetail />} />

      <Route
        path="keuangan/pembayaran-nota"
        element={<AdminPurchaseOrderFarmer />}
      />
      <Route
        path="keuangan/pembayaran-nota/tambah"
        element={<AdminPurchaseOrderFarmerTambah />}
      />
    </Routes>
  );
}
